import { Button, TextField } from '@mui/material';
import React from 'react';
import PhoneInput from 'react-phone-input-2';
import GetLocation from '../../../shared/GetLocation';
import { useStoreState } from 'easy-peasy';
import { useMatch } from 'react-router-dom';

const BillingDetails = ({
  handleSubmit,
  handleInputChange,
  billingDetails,
  mobile,
  setMobile,
  setBillingDetails
}) => {
  const user = useStoreState((state) => state.user);
  const meeting = useMatch('/therapists/*');
  const selfAssessment = useMatch('/self-assessments/*');

  const selectCity = (e) => {
    if (e?.terms[2]) {
      setBillingDetails((prev) => ({
        ...prev,
        city: e?.terms[0]?.value,
        state: e?.terms[1]?.value,
        country: e?.terms[2]?.value
      }));
    } else {
      setBillingDetails((prev) => ({
        ...prev,
        city: e?.terms[0]?.value,
        state: e?.terms[0]?.value,
        country: e?.terms[1]?.value
      }));
    }
  };

  return (
    <>
      <h3>Billing Details</h3>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <TextField
          required
          onChange={handleInputChange}
          fullWidth
          name="name"
          size="small"
          type="text"
          // helperText="Please fill this field"
          value={billingDetails.name}
          label={'Name'}
          style={{ marginTop: '15px' }}
        />
        <TextField
          disabled={user}
          onChange={handleInputChange}
          fullWidth
          name="email"
          size="small"
          type="email"
          // helperText="Please fill this field"
          value={billingDetails.email}
          label={'Email'}
          style={{ marginTop: '15px' }}
          required
        />
        <div style={{ position: 'relative', marginTop: '15px' }}>
          <label
            style={{
              position: 'absolute',
              top: '-10px',
              left: '10px',
              backgroundColor: '#fff',
              padding: '0 4px',
              fontSize: '12px',
              color: '#666',
              zIndex: 999
            }}>
            Mobile <span>*</span>
          </label>
          <PhoneInput
            placeholder="Mobile"
            country={'in'}
            value={mobile}
            onChange={setMobile}
            inputStyle={{ width: '100%', height: '40px' }}
            containerStyle={{ marginTop: '15px' }}
            buttonStyle={{
              backgroundColor: '#fff'
            }}
          />
        </div>

        <TextField
          required
          label="Street 1"
          variant="outlined"
          fullWidth
          style={{ marginTop: '15px', marginBottom: '15px' }}
          name="street1"
          placeholder="Street 1"
          value={billingDetails.street1}
          onChange={handleInputChange}
          size="small"
          inputProps={{ maxLength: 100 }}
        />

        <TextField
          required
          label="Street 2"
          variant="outlined"
          fullWidth
          style={{ marginBottom: '15px' }}
          name="street2"
          placeholder="Street 2"
          value={billingDetails.street2}
          onChange={handleInputChange}
          size="small"
          inputProps={{ maxLength: 100 }}
        />

        <GetLocation
          label="City"
          defaultValue=""
          address={billingDetails.city}
          addressSelected={(e) => selectCity(e)}
        />

        <TextField
          type="number"
          required
          label="Postal Code"
          variant="outlined"
          fullWidth
          style={{ marginBottom: '5px', marginTop: '15px' }}
          name="postalCode"
          placeholder="Postal Code"
          value={billingDetails.postalCode}
          onChange={handleInputChange}
          size="small"
          inputProps={{ maxLength: 6 }}
        />

        <div className="flex-container justify-between">
          <Button
            variant="outlined"
            size="small"
            style={{ marginTop: '20px' }}
            onClick={() => window.history.back()}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            size="small"
            style={{ marginTop: '20px' }}
            disabled={
              !mobile ||
              !billingDetails.city ||
              !billingDetails.name ||
              !billingDetails.email ||
              !billingDetails.street1 ||
              !billingDetails.street2 ||
              !billingDetails.postalCode
            }>
            {meeting ? 'Confirm Booking' : selfAssessment ? 'Start Assessment' : null}
          </Button>
        </div>
      </form>
    </>
  );
};

export default BillingDetails;
